import { computed } from 'vue';

export const FACTOR = 25.4;
export const DIM_PROPS = ['Ancho', 'Alto', 'Largo'];

export function isDimensionesProp(prop) {
  return DIM_PROPS.includes(prop);
}

// mm -> unidad visual (mm / in / cm)
export function milimeterVisualTo(mm, unit) {
  const val = Number(mm ?? 0);
  if (!Number.isFinite(val)) return 0;

  if (unit === 'in') return +(val / FACTOR).toFixed(4);
  if (unit === 'cm') return +(val / 10).toFixed(4);
  return val;
}

// visual -> mm
export function visualToMilimeter(value, unit) {
  const val = Number(value ?? 0);
  if (!Number.isFinite(val)) return 0;

  if (unit === 'in') return val * FACTOR;
  if (unit === 'cm') return val * 10;
  return val;
}

/**
 * @param targetRef - Una función que retorna el valor actual del target (para mantener reactividad)
 * @param unitRef
 * @param emits
 */
export function useConverter(targetRef, unitRef, emits) {
  function converted(field) {
    return computed({
      get() {
        const currentTarget = typeof targetRef === 'function' ? targetRef() : targetRef;
        const raw = currentTarget[field] ?? 0;
        return unitRef.value === 'in' ? +(raw / FACTOR).toFixed(4) : raw;
      },
      set(val) {
        const convertedValue = unitRef.value === 'in' ? val * FACTOR : val;

        // Siempre usar la referencia actual del target
        const currentTarget = typeof targetRef === 'function' ? targetRef() : targetRef;

        // Crear una copia inmutable del objeto actual
        const inmutable = {
          ...currentTarget,
          [field]: convertedValue,
        };

        if (emits) {
          emits('update:modelValue', inmutable);
        }
      },
    });
  }

  return { converted };
}
